module.exports = __webpack_public_path__ + "static/img/logo.d27df3f5.svg";